module.exports = __webpack_public_path__ + "img/niddle.ece60c26.png";